<main>
  <button (click)="getNewPhoto()">Get Photo</button>
  <img *ngIf="photoUrl" [src]="photoUrl" alt="photo" />
</main>
